import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GeneralHelper } from 'src/app/helpers/general-helper';
import Board from 'src/app/model/product/board/board';
import BoardConstructionMaterial from 'src/app/model/product/board/board-construction-materials';
import {
  SignConstructionMaterialType,
  SignConstructionMaterialTypeChoiceArray,
  SupportedLengthsByMaterialTypeOrdinal
} from 'src/app/model/product/board/sign-construction-material-type';

@Component({
  selector: 'board-loadlist',
  templateUrl: './board-load-list.component.html',
  styleUrls: ['./board-load-list.component.scss']
})
export class BoardLoadListComponent implements OnInit {
  @Input()
  board: Board;

  @Input()
  disabled: boolean = false;

  @Output()
  update = new EventEmitter<any>();

  constructionMaterialTypeChoices: SignConstructionMaterialType[];
  supportedLengthsByConstructionMaterialTypeOrdinal: Map<number, Set<number>>;

  ngOnInit(): void {
    this.constructionMaterialTypeChoices = SignConstructionMaterialTypeChoiceArray;
    this.supportedLengthsByConstructionMaterialTypeOrdinal = SupportedLengthsByMaterialTypeOrdinal;
  }

  addConstructionMaterial(): void {
    this.board.boardConstructionMaterials.push(new BoardConstructionMaterial());
    this.update.emit();
  }

  removeMaterial(index: number): void {
    this.board.boardConstructionMaterials.splice(index, 1);
    this.update.emit();
  }

  getConstructionMaterialTypeLengthChoices(
    type: SignConstructionMaterialType
  ): Set<number> {
    return this.supportedLengthsByConstructionMaterialTypeOrdinal.get(
      type.ordinal
    );
  }

  compareConstructionMaterialType(
    b1: SignConstructionMaterialType,
    b2: SignConstructionMaterialType
  ): boolean {
    if (b1 == null && b2 == null) {
      return true;
    } else if (b1 != null && b2 != null) {
      if (b1.ordinal === b2.ordinal) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  trackById(index: number, obj: any): number {
    return GeneralHelper.trackById(index, obj);
  }
}
